import React, { useEffect, useRef, useState } from 'react'
import Header from '../Header/Header'
import LegalRegText from './LegalRegText'
import { ShowFrontEndContext } from './types'
import CreateNewComplaint from './complaints/CreateNewComplaint'
import { useDispatch } from 'react-redux'
import { getInstructionsApi } from '../../redux/instruction/instructionApiCalls'
import ShowInstructions from './ShowInstructions'
import OurPartner from './OurPartner'
import { ShowPartnerApi } from '../../redux/partners/partnerApiCalls'
import ShowNews from './news/ShowNews'
import Footer from './Footer'
import { getNewsApi } from '../../redux/news/newsApiCalls'
import OurWork from './OurWork'

const ShowFrontEnd:React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const onClose = () => {
    setIsOpen(!isOpen)
  }

  const dispatch: any = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getInstructionsApi());
      await dispatch(ShowPartnerApi());
      await dispatch(getNewsApi());
    };
    fetchData();
  }, [dispatch]);


  const HomePageRef = useRef(null)
  const NosServicesRef = useRef()
  const LegalRegTextRef = useRef(null)
  const InstructionRef = useRef(null)
  const ComplaintRef = useRef(null)
  const NewsRef = useRef(null)

  const [showImage, setShowImage] = useState(false)

  return (
    <ShowFrontEndContext.Provider value={{
      NosServicesRef,
      LegalRegTextRef,
      HomePageRef,
      InstructionRef,
      ComplaintRef,
      NewsRef,
      showImage, setShowImage,
    }}>
      <Header toggleOffcanvas={onClose} />
      {/* <FullNavbarSideBar /> */}

      <div className='container mx-auto pt-20' ref={HomePageRef}>
        <OurWork />
        <LegalRegText />
        <ShowInstructions />
        <ShowNews />
        <CreateNewComplaint />
        <OurPartner />
        {/* <Offcanvas isOpen={isOpen} onClose={onClose}/> */}
      </div>
      <Footer />
    </ShowFrontEndContext.Provider>
  )
}

export default ShowFrontEnd